import { render, staticRenderFns } from "./ListaModulosClientes.vue?vue&type=template&id=ba971056&"
import script from "./ListaModulosClientes.vue?vue&type=script&lang=js&"
export * from "./ListaModulosClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports